<template>
  <router-link :to="to" class="nav-item">
    <span class="icon">{{ icon }}</span>
    <span class="title">{{ title }}</span>
  </router-link>
</template>

<script>
export default {
  props: {
    to: String,
    icon: String,
    title: String
  }
}
</script>

<style scoped>
.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  color: var(--my-white);
  text-decoration: none;
  opacity: 0.7;
  transition: all 0.3s ease;
  flex: 1;
  background: transparent;
}

.nav-item:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.05);
}

.icon {
  font-size: 20px;
  margin-bottom: 4px;
}

.title {
  font-size: 12px;
}
</style>
